export default [
  {
    title: '人员',
    key: 'opName'
  },
  {
    title: '媒体',
    key: 'mediaName',
    overflow: true
  },
  {
    title: '中间件游戏',
    key: 'midGameName',
    width: 180,
    overflow: true
  },
  {
    title: '平台',
    key: 'platformName'
  },
  {
    title: '归因消耗',
    key: 'thirtyDayAmount',
    sortable: 'custom'
  },
  {
    title: '归因自然月ROI',
    key: 'thirtyDayRoi',
    sortable: 'custom'
  },
  {
    title: '归因30日ROI',
    key: 'thirtyDayCycleRoi',
    sortable: 'custom'
  }
]
